import script from "./GuideCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideCTA.vue?vue&type=script&setup=true&lang=ts"

import "./GuideCTA.vue?vue&type=style&index=0&id=1867f35f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1867f35f"]])

export default __exports__